import React from "react";
import StoreBankDetails from "../overview/StoreBankDetails";

const BankDetails = ({ storeId }: { storeId: string }) => {
  return <StoreBankDetails storeId={storeId} />;
};

export default BankDetails;
